import { render } from "./PlaceTable.vue?vue&type=template&id=bf61d41c&scoped=true"
import script from "./PlaceTable.vue?vue&type=script&lang=js"
export * from "./PlaceTable.vue?vue&type=script&lang=js"

import "./PlaceTable.vue?vue&type=style&index=0&id=bf61d41c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf61d41c"]])

export default __exports__